import axios from '@/libs/api.request'

export const getAbTestList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/experiment'
  })
}

export const getAbTestCapabilities = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/experiment/capabilities'
  })
}

export const getAbTestUser = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/experiment/creators'
  })
}

export const addAbTest = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/experiment'
  })
}

export const editAbTest = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/experiment'
  })
}

export const delAbTest = (id) => {
  return axios.request({
    method: 'delete',
    url: '/experiment/' + id
  })
}
export const getAbTestInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/experiment/' + id
  })
}

export const stopAbTest = (id) => {
  return axios.request({
    method: 'put',
    url: `/experiment/${id}/stop`
  })
}

export const getDefaultGroup = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: `/experiment/control-group-param`
  })
}

export const startAbTest = (id) => {
  return axios.request({
    method: 'put',
    url: `/experiment/${id}/start`
  })
}